import * as Types from '../actions/Types'
import DB from '../database/offlineDB.json'

const INITIAL_STATE = {
  isValidatingToken: true,
  isFetching: false,
  isSigningIn: false,
  fetched: false,
  tokenFetched: false,
  token: null,
  isCreating: false,
  isUpdating: false,
  errorUpdating: null,
  pushNotificationEnabled: false,
  isAdmin: false,
  isJanitor: false,
  isCorpAdmin: false,
  isResetingPassword: false,
  errorResetingPassword: false,
  isValidatingSignUpCode: false,
  errorValidatingSignUpCode: null,
  joiningCommunity: null,
  errorCreating: false,
  offlineModeSignedIn: false,
  isValidatingEmail: false,
  isCreatingCorporation: false
}

export default (state = INITIAL_STATE, action) => {
  const { type, payload, errorStatus } = action
  switch (type) {
    case Types.ENABLE_PUSH_NOTIFICATIONS:
      return {
        ...state,
        pushNotificationEnabled: payload
      }
    case Types.VALIDATE_USER:
      return {
        ...state,
        isValidatingToken: true
      }
    case Types.VALIDATE_USER_SUCCESS:
      return {
        ...state,
        isValidatingToken: false,
        tokenFetched: true,
        token: payload.token,
        isAdmin: payload.isAdmin,
        isJanitor: payload.isJanitor,
        isCorpAdmin: payload.isCorpAdmin
      }
    case Types.INIT_OFFLINE_MODE:
      return {
        ...state,
        isValidatingToken: false,
        tokenFetched: true,
        token: DB.user.token,
        isAdmin: DB.user.isAdmin,
        isJanitor: DB.user.isJanitor,
        isCorpAdmin: DB.user.isCorpAdmin,
        fetched: true,
        offlineModeSignedIn: true
      }
    case Types.VALIDATE_USER_FAILED:
      return {
        ...state,
        isValidatingToken: false
      }
    case Types.SIGN_IN_USER:
      return {
        ...state,
        isSigningIn: true
      }
    case Types.SIGN_IN_USER_SUCCESS:
      return {
        ...state,
        isSigningIn: false,
        token: payload.token,
        isAdmin: payload.isAdmin,
        isJanitor: payload.isJanitor,
        isCorpAdmin: payload.isCorpAdmin
      }
    case Types.SIGN_IN_USER_FAILED:
      return {
        ...state,
        isSigningIn: false
      }
    case Types.CREATE_CORPORATION:
      return {
        ...state,
        isCreatingCorporation: true
      }
    case Types.CREATE_CORPORATION_SUCCESS:
      return {
        ...state,
        isCreatingCorporation: false,
        token: payload.token,
        isAdmin: payload.isAdmin,
        isJanitor: payload.isJanitor,
        isCorpAdmin: payload.isCorpAdmin
      }
    case Types.CREATE_CORPORATION_FAILED:
      return {
        ...state,
        isCreatingCorporation: false
      }
    case Types.GET_SELF:
      return {
        ...state,
        isFetching: true
      }
    // All data needs to be set here.
    case Types.GET_SELF_SUCCESS:
      return {
        ...state,
        isFetching: false,
        fetched: true
      }
    case Types.GET_SELF_FAILED:
      return {
        ...state,
        isFetching: false
      }
    case Types.UPDATE_USER:
      return {
        ...state,
        isUpdating: true,
        errorUpdating: null
      }
    case Types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: null
      }
    case Types.UPDATE_USER_FAILED:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: payload
      }
    case Types.RESET_PASSWORD:
      return {
        ...state,
        isResetingPassword: true,
        errorResetingPassword: false
      }
    case Types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isResetingPassword: false,
        errorResetingPassword: false
      }
    case Types.RESET_PASSWORD_FAILED:
      return {
        ...state,
        isResetingPassword: false,
        errorResetingPassword: true
      }
    case Types.VALIDATE_SIGN_UP_CODE:
      return {
        ...state,
        isValidatingSignUpCode: true,
        errorValidatingSignUpCode: null
      }
    case Types.VALIDATE_SIGN_UP_CODE_SUCCESS:
      return {
        ...state,
        isValidatingSignUpCode: false,
        errorValidatingSignUpCode: null,
        joiningCommunity: payload
      }
    case Types.VALIDATE_SIGN_UP_CODE_ERROR:
      return {
        ...state,
        isValidatingSignUpCode: false,
        errorValidatingSignUpCode: errorStatus
      }
    case Types.CREATE_USER:
      return {
        ...state,
        isCreating: true,
        errorCreating: false
      }
    case Types.CREATE_USER_SUCCESS:
      return {
        ...state,
        isCreating: false,
        tokenFetched: true,
        token: payload.token,
        isAdmin: payload.isAdmin,
        isJanitor: payload.isJanitor,
        isCorpAdmin: payload.isCorpAdmin,
        errorCreating: false
      }
    case Types.CREATE_USER_ERROR:
      return {
        ...state,
        isCreating: false,
        errorCreating: true
      }
    case Types.SIGN_OUT_USER:
      return { ...INITIAL_STATE }
    case Types.VALIDATE_EMAIL_IS_UNIQUE:
      return {
        ...state,
        isValidatingEmail: true
      }
    case Types.VALIDATE_EMAIL_IS_UNIQUE_SUCCESS:
      return {
        ...state,
        isValidatingEmail: false
      }
    case Types.VALIDATE_EMAIL_IS_UNIQUE_FAILED:
      return {
        ...state,
        isValidatingEmail: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/User.js